import React, { useEffect, useState } from "react";
import TicketLogo from "../../assets/Loginimg.png"
import { getCategories, postSupport } from "../../lib/api";
import Button from "../../components/ui/Button";
import toast from "react-hot-toast";

const SearchIcon = () => <span className="material-icons text-[20px]">search</span>;
const PlusIcon = () => <span className="material-icons text-[20px]">add</span>;
const MinusIcon = () => <span className="material-icons text-[20px]">remove</span>;

export default function Support() {
  const [openIndex, setOpenIndex] = useState(null);

  const [formState, setFormState] = useState({
    name: "",
    email: "",
    category: "",
    description: "",
  })
  const [submitted, setSubmitted] = useState(false);
  const [categories, setCategories] = useState({
    key: "",
    label: "",
  })

  useEffect(() => {
    const dialog = async () => {
      const data = await getCategories();
      // console.log(data);
      setCategories(data)

    }
    // setCategories(dialog.data)

    dialog();
  }, [])
  // console.log(categories);


  const handleSave = async (e: any) => {
    e.preventDefault();
    // console.log(e);
    // console.log(formState);

    setSubmitted(true);
    // if(!formState.category){
    //   alert("category mandatory.")
    //   return
    // }
    if (!formState.description || !formState.category || !formState.email || !formState.name) {
      return
    }

    try {
      // console.log("Submitting support ticket to API:", formState);
      await postSupport(formState)
      // console.log("Form delivered");
      alert("Form Submitted. Support Team will contact you.")
      setFormState({
        name: "",
        email: "",
        description: "",
        category: "",
      })
      setSubmitted(false);

    } catch (e:any) {
      // console.error(e);
      toast.error(e?.response?.data?.error ||
        e?.response?.data?.message ||
         e?.response?.data?.detail||"Failed to send details")
      
    }
  }

  const handleChange = (e: any) => {
    // console.log(e);
    const { name, value } = e.target;

    setFormState((prev) => ({ ...prev, [name]: value }));


  }
  const handleEmailClick = () => {
  const to = "team@roott.one";
  const subject = encodeURIComponent("Support Request");
  const body = encodeURIComponent("Hi Roott Team,\n\nI need help with:");

  const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}&body=${body}`;

  const newWindow = window.open(gmailUrl, "_blank");

  setTimeout(() => {
    if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
      window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
    }
  }, 500);
};


  const faqs = [
    {
      question: "What is ROOTT?",
      answer:
        "ROOTT is an all-in-one funding platform combining grant discovery, AI-powered writing, organisation tools, and soon crowdfunding & investor features.",
    },
    {
      question: "How does grant discovery work?",
      answer:
        "ROOTT uses automated scanning and AI classification to bring relevant grants to you based on your profile and eligibility.",
    },
    {
      question: "What does the AI Writer generate?",
      answer:
        "It creates structured draft responses, summaries, budgets, and proposal sections tailored to both the grant criteria and your onboarding data.",
    },
    {
      question: "Does ROOTT guarantee funding?",
      answer:
        "No platform can guarantee a successful application, but ROOTT improves quality, speed, and accuracy significantly.",
    },
    {
      question: "How do I get support?",
      answer:
        "You can reach us anytime at team@roott.one.",
    },
    {
      question: "How often are grants updated?",
      answer:
        "Grants are updated continuously via automated tools and manual verification.",
    },
    {
      question: "Can I save and organise grants?",
      answer:
        "Yes — your saved grants, drafts, notes, and documents all appear neatly in your dashboard.",
    },
    {
      question: "What features are coming next?",
      answer:
        "Crowdfunding page builder, investor matching, social media funding tools, and the community hub.",
    },
  ];


  const toggleFAQ = (index: any) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="border p-6 bg-[#F1F1F1] shadow-sm">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Support</h1>
          <p className="mt-2 text-[#777B7F]">
            We're here to help. Find the answer you need or get in touch with
            our team.
          </p>
        </div>
        <div>
          {/* <a href="mailto:team@roott.one" className="bg-[#93C893] px-4 py-2 rounded-lg hover:opacity-90"> */}
            <Button
  onClick={handleEmailClick
  }
>
  Email Support
</Button>
          {/* </a> */}
        </div>
      </div>

      {/* Search */}
      {/* <div className="relative w-full py-6">
        <span className="material-icons absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-[20px]">
          search
        </span>
        <input
          type="search"
          className="w-full pl-10 pr-3 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Search the community"
        />
      </div> */}


      {/* FAQ Section */}
      <div>
        <h2 className="text-lg font-semibold mb-4 mt-6">
          Frequently Asked Question (FAQ)
        </h2>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-sm"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center p-4 bg-white hover:bg-gray-50 transition"
              >
                <span className="text-gray-800 font-medium">{faq.question}</span>
                <span className="border px-0 flex items-center rounded-xl">
                  {openIndex === index ? <MinusIcon /> : <PlusIcon />}
                </span>

              </button>
              {openIndex === index && (
                <div className="p-4 text-[#777B7F] bg-white border-t">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Support Ticket Section */}
      <div className=" p-1 rounded-xl shadow-sm mt-8">
        <h2 className="text-lg font-semibold mb-8">Raise a Support Ticket</h2>
        <div className="flex flex-col md:flex-row items-center bg-white p-6 gap-6">
          {/* Illustration */}
          <div className="w-full md:w-1/3 flex justify-center">
            <img src={TicketLogo} alt="Support Illustration" className="max-h-48 object-contain" />
          </div>

          {/* Form */}
          <div className="w-full md:w-2/3">
            <form className="space-y-4">
              <div>
                <label className="text-sm">Your Name</label>
                <input
                  type="text"
                  name="name"
                  value={formState.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  className="w-full mt-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <span className="text-red-500 text-sm">{submitted && !formState.name ? "* Name required" : ""}</span>
              </div>
              <div>
                <label className="text-sm">Email</label>
                <input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  value={formState.email}
                  placeholder="Enter your email address"
                  className="w-full mt-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <span className="text-red-500 text-sm">{submitted && !formState.email ? "* Email required" : ""}</span>
              </div>
              <div>
                <label className="text-sm">Category</label>
                <select
                  className="w-full mt-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                  name="category"
                  value={formState.category}
                  onChange={handleChange}
                >
                  <option value="">Select option</option>

                  {categories && Array.isArray(categories) && categories.length > 0 ? (
                    categories.map((cat: any) => (
                      <option key={cat.key} value={cat.key}>
                        {cat.label}
                      </option>
                    ))
                  ) : (
                    <option>Loading...</option>
                  )}

                  {/* <option value="general">general</option>
                  <option value="bug">bug</option>
                  <option value="feature">feature</option>
                  <option value="other">other</option> */}
                </select>
                <span className="text-red-500 text-sm">{submitted && !formState.category ? "* Category required" : ""}</span>
              </div>
              <div>
                <label className="text-sm">Description</label>
                <textarea
                  rows={3}
                  placeholder="Enter your issue here..."
                  className="w-full mt-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                  name="description"
                  value={formState.description}
                  onChange={handleChange}
                ></textarea>
                <span className="text-red-500 text-sm">{submitted && !formState.description ? "* Description required" : ""}</span>
              </div>
              <button
                type="submit"
                onClick={handleSave}
                className="w-full bg-[#93C893] py-2 rounded-lg font-medium hover:opacity-90"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
